import { FC, useEffect, useState } from "react";
import "../../styles/components.css";
import "../../styles/standard-viewer.css";
import { useAppStateContext } from "../../middleware/context/state-context-provider";
import { Navigate } from "react-router-dom";
import {
  CheckAuthentication,
  UpdateUserLastActionDate,
} from "../../helper/ui/methods";
import ResponseDialog from "../ui/user/response-dialog";
import { StandardViewport } from "../ui/viewer/standard-viewport";
import { PropertiesMenu } from "../ui/viewer/properties-menu";
import { FormatDateBE } from "../../helper/general/methods";
import { ModelUploadInterface } from "../../middleware/interfaces/file/model-upload-interface";
import MenuButton from "../ui/user/menu-button";
import * as BUI from "@thatopen/ui";

// Add this before the StandardViewer component
declare module "react" {
  namespace JSX {
    interface IntrinsicElements {
      "bim-panel": any;
      "bim-panel-section": any;
    }
  }
}

export const StandardViewer: FC = () => {
  const [state, dispatch] = useAppStateContext();
  const [propertiesPanelReveal, setPropertiesPanelReveal] = useState(false);

  useEffect(() => {
    if (state.user === null || state.user === undefined) {
      console.log("CHECKING AUTHENTICATION!");
      CheckAuthentication(dispatch);
    } else {
      BUI.Manager.init();
    }
  }, []);

  useEffect(() => {
    if (state.user) {
      UpdateUserLastActionDate(state.user, dispatch);
    }
  }, [state.user]);

  useEffect(() => {
    //PREPARE AND UPLOAD MODEL FRAGMENTS
    if (
      state.data !== null &&
      typeof state.data === "object" &&
      typeof state.data.then === "function"
    ) {
      state.data
        .then((result: any) => {
          const uploadModel: ModelUploadInterface = {
            email: state.user?.email!,
            projectID: state.user?.openProject?.projectID!,
            projectUserRole: state.user?.openProject?.projectUserRole!,
            modelFileParentID: state.user?.openFolder
              ? state.user?.openFolder.folderID
              : null,
            modelName: result["modelName"],
            modelFileType: "ifc",
            modelFileSize: state.openModel["modelFileSize"],
            modelFragmentsSize: result["modelFragmentsSize"],
            modelUploadDate: FormatDateBE(new Date()),
            modelData: {
              modelFragmentsData: result["modelFragmentsData"],
              modelFileData: state.openModel["modelFileData"],
            },
            type: "ModelUploadInterface",
          };
          dispatch({ type: "UPLOAD_FILE", payload: uploadModel });
        })
        .catch((error: string) => {
          console.error("Promise rejected:", error);
        });
    }
  }, [state.data]);

  useEffect(() => {
    if (propertiesPanelReveal) {
      console.log("SHOW PROPERTIES");
    }
  }, [propertiesPanelReveal]);

  return (
    <>
      {(() => {
        if (state.user !== null && state.user !== undefined) {
          return (
            <div
              id="pageWrapper"
              onClick={() => UpdateUserLastActionDate(state.user!, dispatch)}
            >
              <div id="pageHeader">
                <input id="openFile" type="file" />
                <input id="addFile" type="file" />
                <input id="exportIFC" type="file" />
              </div>
              <div id="leftMenuWrapper">
                <div id="leftMenuButtonWrapper">
                  <MenuButton
                    imageSource="assets/icons/layers.png"
                    alternativeText="LAYERS"
                    buttonSize="small"
                    dispatch={() => {
                      console.log("SHOW LAYERS!");
                    }}
                  />
                  <MenuButton
                    imageSource="assets/icons/properties.png"
                    alternativeText="PROPERTIES"
                    buttonSize="small"
                    dispatch={() => {
                      // dispatch({ type: "SHOW_MODEL_ELEMENT_PROPERTIES" });
                      setPropertiesPanelReveal(!propertiesPanelReveal);
                    }}
                  />
                </div>

                <div id="layerMenu"></div>
                <PropertiesMenu propertiesPanelReveal={propertiesPanelReveal} />
              </div>
              <StandardViewport />
              <ResponseDialog
                user={state.user}
                title="Server Response"
                message={state.response}
                dispatch={dispatch}
              />
              <div id="pageFooter">
                <MenuButton
                  imageSource="assets/icons/isolate.png"
                  alternativeText="ISOLATE"
                  buttonSize="small"
                  dispatch={() => {
                    dispatch({ type: "ISOLATE_MODEL_ELEMENT" });
                  }}
                />
                <MenuButton
                  imageSource="assets/icons/hide.png"
                  alternativeText="HIDE"
                  buttonSize="small"
                  dispatch={() => {
                    dispatch({ type: "HIDE_MODEL_ELEMENT" });
                  }}
                />
                <MenuButton
                  imageSource="assets/icons/unhide.png"
                  alternativeText="UNHIDE"
                  buttonSize="small"
                  dispatch={() => {
                    dispatch({ type: "UNHIDE_ALL_MODEL_ELEMENTS" });
                  }}
                />
              </div>
            </div>
          );
        } else {
          if (state.response !== "") {
            <div
              id="content"
              onClick={() => UpdateUserLastActionDate(state.user!, dispatch)}
            >
              <ResponseDialog
                user={state.user!}
                title="Server Response"
                message={state.response}
                dispatch={dispatch}
              />
            </div>;
          } else {
            return <Navigate to={"/authentication&registration"} />;
          }
        }
      })()}
    </>
  );
};
